/**
 * Case-insensitive name sort for entity pick-lists, returning a new array so
 * the caller never mutates a store's list in place.
 *
 * Shared by BusinessEntityPage.vue and DomainObjectDrawer.vue, which offer the
 * same "pick a related domain object" dropdown and must order it identically.
 */
export const sortEntitiesByName = <T extends { name: string }>(
    list: readonly T[]
): T[] =>
    list
        .slice()
        .sort((a, b) =>
            a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
        );
